const RESOURCE_NAME = "entities/walletPayments";

export default {};
